import React, { useEffect, useState } from "react";
import { CreatePageList } from "../../components/Layouts/PageList";
import { Add } from "../../components/Actions/Add";
import { Box, Tab, Tabs } from "@mui/material";
import CustomDataGrid from "../../components/CustomDataGrid";
import pathRoutes from "../../routes/pathRoutes";
import { GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { setsConfigCalibration } from "./utils/constants";
import MessageDialog from "../../components/Login/MessageDialog";
import { useEfficiencies } from "@services/servicesGenericsTables";
import { useCalibrationTritium } from "./utils/useCalibration";
import { useTabsCalibrtion } from "./utils/useTabCalibration";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "../users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

const CalibrationList: React.FC = () => {
  const navigate = useNavigate();
  const [dataTable, setDataTable] = useState<any>([]);
  const [dialogData, setDialogData] = useState<any>({});
  const { tabValue, setTabValue } = useTabsCalibrtion();
  const { filteredEfficiencies } = useEfficiencies();
  const { filteredCalibration } = useCalibrationTritium();
  const calibrationList = filteredCalibration();
  const efficienciesList = filteredEfficiencies();
  const { isAdmin, isSuperAdmin } = usePermission();

  useEffect(() => {
    if (tabValue === 0) setDataTable(efficienciesList);
    else setDataTable(calibrationList);
  }, [
    JSON.stringify(efficienciesList?.length),
    JSON.stringify(calibrationList?.length),
    tabValue,
    JSON.stringify(calibrationList),
  ]);

  const handleDelete = (params: any) => () => {
    setDialogData({
      component: "Confirm",
      title: `Vas a eliminar el informe con id ${params.row.id}`,
      active: true,
      id: params.id,
    });
  };

  const handleRowDoubleClick = (params: GridRowParams): void => {
    if (isAdmin || isSuperAdmin)
      navigate(
        `${pathRoutes.ADMIN_CALIBRACIONES}/editar/${config[tabValue].set}/${params.id}`
      );
    else
      navigate(
        `${pathRoutes.ADMIN_CALIBRACIONES}/ver/${config[tabValue].set}/${params.id}`
      );
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const config = setsConfigCalibration(handleDelete, navigate);

  const handleComponent = (value: boolean) => {
    setDialogData({ active: false });
  };

  const handleDialogConfirm = (value: boolean) => {
    console.log("Confirmado", value);
  };
  const CurrentFilter = config[tabValue].filterComponent;

  return (
    <CreatePageList
      title="Listado de calibraciones"
      buttonRight={
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Add
            to={`admin/calibraciones/nuevo/${config[tabValue].set}`}
            title="Nueva calibración"
          />
        </PermissionComponentGate>
      }
    >
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="Fields uncertainty tabs"
      >
        {config.map((set, index) => (
          <Tab key={index} label={set.label} />
        ))}
      </Tabs>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}>
        <CurrentFilter />
        <CustomDataGrid
          key={JSON.stringify(dataTable)}
          rows={dataTable}
          columns={config[tabValue].columns}
          search={false}
          handleRowDoubleClick={handleRowDoubleClick}
        />
      </Box>
      <MessageDialog
        data={dialogData}
        handleClose={handleComponent}
        handleConfirm={handleDialogConfirm}
      ></MessageDialog>
    </CreatePageList>
  );
};

export default CalibrationList;
